import { render, staticRenderFns } from "./AutocompletePreset.vue?vue&type=template&id=35c01e97"
import script from "./AutocompletePreset.vue?vue&type=script&lang=ts"
export * from "./AutocompletePreset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports